export enum LandingType {
  DEFAULT = 'default',
  NEXUS = 'nexus',
  ANYPAGE = 'anypage',
  AKENET = 'akenet',
  BLACKPROXY = 'black-proxy',
  ASOCKS = 'asocks',
  SX = 'sx',
}